'use client';
import React from 'react';
import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WaitlistSection from '@/app/home/components/WaitlistSection';

export default function WaitlistPage() {
  return (
    <div style={{ background: '#050510', minHeight: '100vh' }}>
      <Header />
      {/* Cyberpunk top bar */}
      <div
        style={{
          background: 'linear-gradient(90deg, #7b2fff, #00f5ff, #ff00ff, #7b2fff)',
          borderBottom: '1px solid rgba(0,245,255,0.3)',
          padding: '8px 16px',
          textAlign: 'center',
        }}
      >
        <span
          style={{
            fontFamily: 'Barlow Condensed, Arial, sans-serif',
            fontWeight: 900,
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            color: '#050510',
          }}
        >
          🚗 Vertex Premium Launches Sept–Oct 2026 · Reserve Your Spot Now
        </span>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8 py-8 md:py-12 pb-24 md:pb-12">

        {/* Breadcrumb */}
        <div className="flex items-center gap-2 mb-8">
          <Link
            href="/home"
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 700,
              fontSize: '11px',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: '#7b8ab8',
            }}
          >
            Home
          </Link>
          <span style={{ color: '#1a1a4e', fontSize: '14px' }}>›</span>
          <span
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 900,
              fontSize: '11px',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: '#00f5ff',
            }}
          >
            Waitlist
          </span>
        </div>

        {/* Hero copy */}
        <div className="mb-8 text-center">
          <div
            className="inline-block px-3 py-1 mb-4"
            style={{ background: 'rgba(0,245,255,0.08)', border: '1px solid rgba(0,245,255,0.4)' }}
          >
            <span
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 900,
                fontSize: '11px',
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                color: '#00f5ff',
              }}
            >
              Launching Sept – Oct 2026
            </span>
          </div>

          <h1
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(36px, 7vw, 72px)',
              textTransform: 'uppercase',
              color: '#e0e8ff',
              lineHeight: 0.92,
              letterSpacing: '0.01em',
              marginBottom: '12px',
              textShadow: '0 0 40px rgba(0,245,255,0.15)',
            }}
          >
            Reserve Your Spot
            <br />
            <span
              style={{
                color: '#00f5ff',
                fontWeight: 700,
                fontSize: 'clamp(20px, 4vw, 40px)',
                textShadow: '0 0 20px rgba(0,245,255,0.5)',
              }}
            >
              Before We Go Live.
            </span>
          </h1>

          <p
            style={{
              fontSize: '15px',
              color: '#a0b0d8',
              lineHeight: 1.7,
              maxWidth: '560px',
              margin: '0 auto 24px',
            }}
          >
            Vertex Premium Mobile Detailing launches in Mesquite, NV this fall. Sign up now to lock in priority booking and exclusive launch-day pricing — no commitment required.
          </p>

          {/* Perks */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
            {[
              'Priority Booking',
              'Launch-Day Pricing',
              'No Commitment',
              'Early Updates',
            ]?.map((perk) => (
              <span
                key={perk}
                style={{
                  background: 'rgba(0,245,255,0.08)',
                  color: '#00f5ff',
                  fontFamily: 'Barlow Condensed, Arial, sans-serif',
                  fontWeight: 900,
                  fontSize: '11px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  padding: '6px 14px',
                  border: '1px solid rgba(0,245,255,0.3)',
                }}
              >
                ◆ {perk}
              </span>
            ))}
          </div>
        </div>

        {/* Waitlist form */}
        <WaitlistSection />

        {/* Back link */}
        <div className="text-center mt-8">
          <Link
            href="/home"
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 700,
              fontSize: '12px',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: '#7b8ab8',
              textDecoration: 'underline',
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
